import { render, staticRenderFns } from "./courseH.vue?vue&type=template&id=479eb8c5&scoped=true&"
import script from "./courseH.vue?vue&type=script&lang=js&"
export * from "./courseH.vue?vue&type=script&lang=js&"
import style0 from "./courseH.vue?vue&type=style&index=0&id=479eb8c5&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "479eb8c5",
  null
  
)

export default component.exports